import { Show, For, useContext } from 'solid-js';
import theme from '../../../../style/theme';
import removeAmpersand from '../../../../tools/remove-ampersand';
import { removeTrailingSlash } from '../../../../tools/remove-trailing-slash';
import urlMatches from '../../../../tools/url-match';
import { GlobeIcon } from '../../../icons-library/globe';
import { LinkType } from '../../menu-header-types';
import { StyledMenuHeaderLinks, StyledMenuHeaderLink, StyledMenuHeaderChangeLanguage, StyledMenuHeaderLinkPatientOrHcpContainer, StyledMenuHeaderLinkPatientOrHcp, StyledMenuHeaderLinkExternal } from './menu-header-nav.styles';
import { AppContext } from '../../../../app-context-provider/app-context-provider';
import { toggleCountrySelectionMenu } from '../../../../stores/locale-store';
import { StarIcon } from '../../../icons-library/star';

export type MenuHeaderNavProps = {
    links?: LinkType[];
    handleCloseMenuClick: () => void;
};

export const MenuHeaderNav = (props: MenuHeaderNavProps) => {
    const { siteInfo, shopPage, contactUsPage, appStore, shop, localize, myContentPage } = useContext(AppContext);

    const handleOnChangeLanguageClick = () => {
        props.handleCloseMenuClick();
        toggleCountrySelectionMenu();
    };

    
    return (
        <StyledMenuHeaderLinks>
            <Show when={!siteInfo?.siteType || siteInfo?.siteType === 'default'}>
                <Show when={myContentPage.url && myContentPage.url !== ''}>
                    <StyledMenuHeaderLink
                        href={removeTrailingSlash(myContentPage.url)}
                        onClick={() => props.handleCloseMenuClick()}
                        active={urlMatches(myContentPage.url)}
                    >
                        <StarIcon
                            altText={localize('header_my_content_icon', 'Link to My content')}
                            aria-label={localize('header_my_content_icon', 'Link to My content')}
                            fill={theme.palette.gray}
                            height={1.5}
                            width={1.5}
                        />

                        <span>{localize('my-content', 'My content')}</span>
                    </StyledMenuHeaderLink>
                </Show>

                <StyledMenuHeaderChangeLanguage onClick={handleOnChangeLanguageClick}>
                    <GlobeIcon
                        altText={localize('header_country_selection_icon', 'Open country selection menu')}
                        aria-label={localize('header_country_selection_icon', 'Open country selection menu')}
                        fill={theme.palette.gray}
                        height={1.5}
                        width={1.5}
                    />

                    <span>{localize('change-language', 'Change language')}</span>
                </StyledMenuHeaderChangeLanguage>

                <Show when={shopPage?.url && shopPage.url !== ''}>
                    <StyledMenuHeaderLinkExternal
                        href={removeTrailingSlash(shopPage.url)}
                        onClick={() => props.handleCloseMenuClick()}
                        active={urlMatches(shopPage.url)}
                    >
                        {localize('shop', 'Shop')}
                    </StyledMenuHeaderLinkExternal>
                </Show>
            </Show>

            <Show when={siteInfo?.siteType === 'atos-care'}>
                <Show when={shop.basketPage?.url && shop.basketPage.url !== ''}>
                    <StyledMenuHeaderLink
                        href={removeTrailingSlash(shop.basketPage.url)}
                        onClick={() => props.handleCloseMenuClick()}
                        active={urlMatches(shop.basketPage.url)}
                    >
                        {removeAmpersand(shop.basketPage.title)}
                    </StyledMenuHeaderLink>
                </Show>

                <Show when={contactUsPage?.url && contactUsPage.url !== ''}>
                    <StyledMenuHeaderLink
                        href={removeTrailingSlash(contactUsPage.url)}
                        onClick={() => props.handleCloseMenuClick()}
                        active={urlMatches(contactUsPage.url)}
                    >
                        {removeAmpersand(contactUsPage.title)}
                    </StyledMenuHeaderLink>
                </Show>
            </Show>


            <StyledMenuHeaderLinkPatientOrHcpContainer>
                <For each={props?.links}>
                    {(link: LinkType, index) => (
                        <Show when={link.url && link.url !== ''}>
                            <StyledMenuHeaderLinkPatientOrHcp
                                href={removeTrailingSlash(link.url)}
                                onClick={() => props.handleCloseMenuClick()}
                                active={urlMatches(link.url) || (appStore.isHcp() && index() === 1)}
                            >
                                {removeAmpersand(link.title)}
                            </StyledMenuHeaderLinkPatientOrHcp>
                        </Show>
                    )}
                </For>
            </StyledMenuHeaderLinkPatientOrHcpContainer>

        </StyledMenuHeaderLinks>
    );
};